<template>
  <div class="cooked-weights-theme">
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">{{ texts.SCREEN_TITLE }}</h3>
            </div>
            <div class="col-auto">
              <flat-picker
                v-model="date"
                :config="dateConfig"
                class="form-control"
                :placeholder="texts.DATE_PLACEHOLDER"
                @on-change="fetchData"
              />
            </div>
          </div>
        </div>

        <div class="card-body" v-if="loading">
          <div class="text-center py-5">
            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
            <p class="mt-3">{{ texts.LOADING }}</p>
          </div>
        </div>

        <div class="card-body" v-else-if="errorMessage">
          <div class="text-center py-5 text-danger">{{ errorMessage }}</div>
        </div>

        <div class="card-body" v-else-if="!groups.length">
          <div class="text-center py-5">
            <i class="fas fa-exclamation-circle fa-2x text-muted"></i>
            <p class="mt-3 text-muted">{{ texts.EMPTY }}</p>
          </div>
        </div>

        <div class="card-body" v-else>
          <meal-weighing-table
            v-for="meal in meals"
            :key="meal.meal_id"
            :meal="meal"
            :date="date"
            :calories="calories"
            :recipe-grams-by-calorie="recipeGramsByMeal[meal.meal_id]"
            @group-updated="replaceGroup"
            @reload-requested="reloadGroups"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import CookedWeightsGateway from '@/gateways/CookedWeightsGateway'
import MealWeighingTable from './components/MealWeighingTable.vue'
import { todayLocalDate } from '@/utils/localDate'
import { TEXTS } from './cookedWeightsConstants'
import './cookedWeightsTheme.css'

export default {
  name: 'PesosCocidosList',
  components: {
    flatPicker,
    MealWeighingTable
  },
  data () {
    return {
      date: todayLocalDate(),
      dateConfig: { dateFormat: 'Y-m-d', minDate: 'today', maxDate: 'today' },
      loading: false,
      groups: [],
      calories: {},
      recipeGramsByMeal: {},
      errorMessage: '',
      pendingDate: null
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    texts () {
      return TEXTS
    },
    meals () {
      const byMeal = {}
      const order = []
      this.groups.forEach((group) => {
        if (!byMeal[group.meal_id]) {
          byMeal[group.meal_id] = { meal_id: group.meal_id, meal_name: group.meal_name, groups: [] }
          order.push(group.meal_id)
        }
        byMeal[group.meal_id].groups.push(group)
      })
      return order.map((mealId) => byMeal[mealId])
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.errorMessage = ''
      const requestedDate = this.date
      this.pendingDate = requestedDate
      CookedWeightsGateway
        .groups(requestedDate)
        .then((response) => this.applyResponse(requestedDate, response))
        .catch((error) => this.applyError(requestedDate, error))
        .finally(() => this.finishLoading(requestedDate))
    },
    applyResponse (requestedDate, response) {
      if (requestedDate !== this.pendingDate) {
        return
      }
      this.groups = response.data.groups || []
      this.calories = response.data.calories || {}
      this.recipeGramsByMeal = response.data.recipe_grams_by_meal || {}
    },
    applyError (requestedDate, error) {
      console.error('Failed to load cooked weight groups', error)
      if (requestedDate !== this.pendingDate) {
        return
      }
      this.groups = []
      this.errorMessage = this.serverMessageOf(error) || TEXTS.ERROR_FALLBACK
    },
    serverMessageOf (error) {
      return error.response && error.response.data ? error.response.data.message : ''
    },
    reloadGroups () {
      const requestedDate = this.date
      this.pendingDate = requestedDate
      CookedWeightsGateway
        .groups(requestedDate)
        .then((response) => this.applyResponse(requestedDate, response))
        .catch((error) => console.error('Failed to reload cooked weight groups', error))
    },
    finishLoading (requestedDate) {
      if (requestedDate === this.pendingDate) {
        this.loading = false
      }
    },
    replaceGroup (updatedGroup) {
      this.groups = this.groups.map((group) =>
        group.meal_id === updatedGroup.meal_id && group.subgroup_id === updatedGroup.subgroup_id
          ? updatedGroup
          : group
      )
    }
  }
}
</script>
